<template>
  <div class="container">
    <el-row>
      <el-col :span="12">
        <div class="world_timer">
          {{ world_timer }}
          <!-- &lt;/\/\/\/\/\/\/\/\/\ {{ percentage }} % /\/\/\/\/\/\/\/\/\/\&gt; -->
        </div>
      </el-col>
      <el-col :span="12">
        <div class="user_info_detail">
          <i class="el-icon-user" @click="toggleUserInfoBox()"></i>
          <span>{{ current_user_cn }}</span>
          &nbsp;&nbsp;
          <i class="el-icon-switch-button" @click="logOut()" title="退出"></i>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Nav',
  data() {
    return {
      world_timer: '',
      percentage: 0.00,
      showUserInfoBox: false,
      current_user_cn: this.$userinfo.name_cn
    }
  },
  mounted() {
    // var timer = setInterval(() => {
    //   var date = new Date();
    //   var year = date.getFullYear();
    //   var month = date.getMonth() + 1;
    //   var day = date.getDate();
    //   var hours = date.getHours();
    //   var minutes = date.getMinutes();
    //   var seconds = date.getSeconds();
    //   if (month < 10) {
    //     month = '0' + month;
    //   }
    //   if (day < 10) {
    //     day = '0' + day;
    //   }
    //   if (hours < 10) {
    //     hours = '0' + hours;
    //   }
    //   if (minutes < 10) {
    //     minutes = '0' + minutes;
    //   }
    //   if (seconds < 10) {
    //     seconds = '0' + seconds;
    //   }
    //   var today = year + '-' + month + '-' + day;
    //   var now = today + ' ' + hours + ':' + minutes + ':' + seconds;
    //   var start = today + ' 09:00:00';
    //   var target = today + ' 17:30:00';
    //   var already = (new Date(now) - new Date(start)) / 60;
    //   var target = (new Date(target) - new Date(start)) / 60;
    //   if (already <= target) {
    //     this.percentage = Number((already / target * 100).toFixed(5));
    //   } else {
    //     this.percentage = 100;
    //     clearInterval(timer);
    //   }
    // }, 100)

    setInterval(() => {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      if (hours < 10) {
        hours = '0' + hours;
      }
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      if (seconds < 10) {
        seconds = '0' + seconds;
      }
      var today = year + '-' + month + '-' + day;
      var now = today + ' ' + hours + ':' + minutes + ':' + seconds;
      this.world_timer = now
    }, 1000)
  },
  methods: {
    toggleUserInfoBox() {
      this.showUserInfoBox = !this.showUserInfoBox
    },
    userinfoSetting() {
      this.showUserInfoBox = false
      console.log('jump to setting page')
    },
    logOut() {
      this.showUserInfoBox = false
      this.$notify({
        title: 'Tips',
        message: 'Waiting to log out please.'
      })
      this.$axios.post('/users/logout')
        .then((response) => {
          if (response.data.code === 200) {
            sessionStorage.clear()
            localStorage.removeItem('userinfo')
            localStorage.removeItem('menus')
            this.$userinfo.token = ''
            this.$userinfo.refresh_token = ''
            this.$userinfo.token_expired = ''
            this.$router.push('/login')
          }
        })
    }
  }
}
</script>

<style scoped>
.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.container {
  width: 100% !important;
  height: 60px;
}

.container div {
  height: 100%;
}

.user_info_detail {
  padding-right: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.user_info_detail span {
  font-size: 12px;
  margin: 0 8px;
}

.user_info_detail i:hover {
  cursor: pointer;
  color: #409EFF;
}

.world_timer {
  padding-left: 20px;
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Global/Nav.vue